import { ButtonERP } from "@finanedi.es/storybook"
import { faArrowLeft } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getDownloadPrestamoPdf } from "api/Prestamos.service"
import Menu from "common/components/Menu"
import notification from "common/utils/notification"
import { EstadosTipoPrestamo } from "features/Documentos/templates"
import fileDownload from "js-file-download"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { EstadoPrestamo } from "../EstadoPrestamo"

const DetailHeader = ({
  handleRedirectToList,
  prestamo,
  handleDelete,
  handleEdit,
  handleOpenAmortizacionesModal,
  isNewAmortizacionesDisabled,
  pdfData,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const handleDownloadPdf = async (
    id: $TSMigrationFixMe,
    concepto: $TSMigrationFixMe
  ) => {
    try {
      setLoading(true)
      const pdfData = await getDownloadPrestamoPdf(id)

      fileDownload(
        new Blob([pdfData], { type: "application/pdf" }),
        `${concepto.replace(" ", "_")}.pdf`
      )
      setLoading(false)
    } catch (error) {
      setLoading(false)
      notification.errorServidor({
        body: `${t("prestamos.msg.downloadError")}`,
      })
    }
  }

  const getOptions = () => {
    return [
      {
        label: `${t("prestamos.idView.options.editLoan")}`,
        icon: "pi pi-pencil",
        command: handleEdit,
      },
      {
        label: `${t("prestamos.idView.options.editEarlyAmortization")}`,
        icon: "pi pi-check-circle",
        className: `${
          isNewAmortizacionesDisabled ? "option-disabled" : ""
        } tw-text-nowrap`,
        command: !isNewAmortizacionesDisabled && handleOpenAmortizacionesModal,
      },
      {
        template: (
          <div
            onClick={() => handleDownloadPdf(pdfData.id, pdfData.concepto)}
            className='tw-relative'
          >
            <a
              href='#'
              className='p-menuitem-link'
              role='menuitem'
              tabIndex={0}
            >
              <span className='p-menuitem-icon pi pi-file-pdf' />
              <span className='p-menuitem-text'>
                {t("prestamos.idView.options.downloadPdf")}
              </span>
            </a>
            {loading && (
              <div
                className='mr-3 spinner-border tw-text-success spinner-border-sm tw-absolute tw-right-0 tw-top-3'
                role='status'
              />
            )}
          </div>
        ),
      },
      {
        label: `${t("prestamos.idView.options.deleteLoan")}`,
        icon: "pi pi-trash",
        className: "card-approval-delete-option",
        command: handleDelete,
      },
    ]
  }

  return (
    <header className='tw-w-full tw-bg-white tw-flex tw-flex-row tw-items-center tw-justify-between tw-min-h-16 tw-shadow tw-rounded tw-py-4 tw-px-6'>
      <div className='tw-w-fit tw-flex tw-flex-row tw-items-center'>
        <ButtonERP
          customize={{
            type: "white",
            size: "md",
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={() => handleRedirectToList()}
        />

        <p className='tw-ml-3 tw-text-2xl tw-font-normal'>
          {prestamo?.concepto} - <span>{prestamo?.razonSocial}</span>
        </p>
      </div>
      <div className='d-flex align-items-center buttons_container'>
        <div>
          <EstadoPrestamo
            variant={prestamo?.estado}
            t={t}
          />
        </div>
        <div>
          <EstadosTipoPrestamo
            estado={prestamo?.tipoPrestamo}
            className='prestamo-tipo-status'
            t={t}
          />
        </div>
        <div className='tw-rounded tw-w-fit tw-h-fit tw-shadow'>
          <Menu
            items={getOptions()}
            className='menu-actions !tw-w-60'
            buttonClassname
          />
        </div>
      </div>
    </header>
  )
}

export default DetailHeader
